import { render, staticRenderFns } from "./indicesCalculo.vue?vue&type=template&id=222808a4&"
import script from "./indicesCalculo.vue?vue&type=script&lang=js&"
export * from "./indicesCalculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports